import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
	API_URL,
	scroll,
	fmtCurrency,
	getValFromLS,
	setValToLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

import Steps from "./Steps";

const Receipt = ({ data }) => {
	return (
		<table
			className="approved"
			style={{ marginTop: "25px", marginBottom: "25px" }}
		>
			<thead>
				<tr>
					<th className="left" style={{ width: "75%" }}>
						Sponsor Level
					</th>
					<th>Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="left">
						<p
							style={{
								margin: "0",
								marginTop: "5px",
								fontSize: "1.1rem",
							}}
						>
							{data.levelName}
						</p>
					</td>
					<td className="right">{fmtCurrency(data.levelAmt / 100)}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th className="right" style={{ paddingRight: "10px" }}>
						TOTAL
					</th>
					<th className="right">{fmtCurrency(data.levelAmt / 100)}</th>
				</tr>
				<tr>
					<td className="right" style={{ paddingRight: "10px" }}>
						{data.paid}
					</td>
					<td className="right">{data.paidAmt}</td>
				</tr>
			</tfoot>
		</table>
	);
};

const RegSubmitted = () => {
	const [receipt, setReceipt] = useState({});
	const [details, setDetails] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				const orderFromLS = JSON.parse(getValFromLS("order", true));
				const authFromLS = JSON.parse(getValFromLS("auth", true));

				const url = new URL(`${API_URL}/registrationSubmittedInit`);
				const params = {
					id: authFromLS.id,
					orderId: orderFromLS.orderId,
				};
				url.search = new URLSearchParams(params);

				try {
					const response = await fetch(url, {
						method: "GET",
						cache: "no-store",
					});
					const json = await response.json();
					if (json && json.resp === 1) {
						setDetails({
							...authFromLS,
							items: json.items,
							dashboardUrl: json.dashboardUrl,
						});

						if (getValFromLS("receipt", true)) {
							const receiptFromLS = JSON.parse(getValFromLS("receipt", true));
							setReceipt({
								levelName: orderFromLS.level.name,
								levelAmt: orderFromLS.level.amt,
								paid: receiptFromLS.paid,
								paidAmt: receiptFromLS.paidAmt,
							});
						}

						setAlert({});
						scroll();
					} else {
						setAlert({
							type: "error",
							text: "An error has occurred.",
						});
					}
				} catch (error) {
					setAlert({
						type: "error",
						text: "An error has occurred.",
					});
				}
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleClick = () => {
		setValToLS("auth", null, true);
		setValToLS("order", null, true);
		setValToLS("receipt", null, true);
		window.location = `${details.dashboardUrl}`;
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>7</h1>
							<div>
								<p>
									Thank you for submitting your sponsorship registration. An
									email has been sent to the main contact,{" "}
									<strong>{details.email}</strong>, with your Dashboard link to
									use our invite system for managing your guests and other
									sponsor functions during the months leading up to the event.
								</p>

								<p>
									Please remember to check your spam folder if not received
									within a few minutes.
								</p>
							</div>
						</div>

						<div style={{ marginTop: "25px", textAlign: "center" }}>
							<button
								type="button"
								className="btn-alt"
								onClick={() => handleClick()}
							>
								{`Access Sponsor Dashboard`}
							</button>
						</div>

						{receipt.paid && <Receipt data={receipt} />}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={7} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegSubmitted;
